<template>
  <div>
    <hshead title="任务大厅" bgcolor="#fff" page="true"></hshead>
    <div class="order-ul" style="height:100%">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="order-li" v-for="(item, index) in list" :key="index">
          <div class="content-box">
            <div class="content-top">
              <div class="left-img">
                <img src="../assets/images/order/icon.png" alt />
              </div>
              <div class="center-p">
                <div class="center-p-h1">去拍拍自营店</div>
                <div class="center-p-p">1天前</div>
              </div>
              <div class="right-icon">
                <img src="../assets/images/order/ellipsis.png" alt />
              </div>
            </div>
            <div class="content-content">
              <div class="left-p">
                高级套餐
                <span>(30张)</span>
              </div>
              <div class="right-p">¥800.00</div>
            </div>
            <div class="content-iconp iconp1">广州市天河区WWWWW酒店</div>
            <div class="content-iconp iconp2">广州市天河区黄埔大道30号</div>
            <div class="content-iconp iconp3">2019.05.01－2019.05.05</div>
          </div>
          <router-link to class="li-btn">我要接单</router-link>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Tab, Tabs, List } from "vant";
export default {
  name: "MissionHall",
  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      console.info('onLoad', this.list.length)
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    }
  },
  components: {
    hshead,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.order-ul {
  margin-top: -6.2rem;
  .order-li {
    width: 6.7rem;
    background-color: #ffffff;
    box-shadow: 0rem 0.01rem 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    position: relative;
    .content-box {
      padding: 0.47rem 0.3rem;
      .content-top {
        display: flex;
        margin-bottom: 0.15rem;
        .left-img {
          padding-right: 0.2rem;
          width: 0.62rem;
          img {
            width: 0.62rem;
            height: 0.62rem;
          }
        }
        .center-p {
          width: 4.6rem;
          padding-bottom: 0.4rem;
          .center-p-h1 {
            display: block;
            font-family: PingFangSC-Medium;
            font-size: 0.28rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0rem;
            color: #666666;
          }
          .center-p-p {
            height: 0.21rem;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0.4rem;
            letter-spacing: 0rem;
            color: #00bbfb;
          }
        }
        .right-icon {
          flex: 1;
          img {
            width: 0.64rem;
            height: 0.64rem;
            background-color: #ffffff;
          }
        }
      }
      .content-content {
        display: flex;
        .left-p {
          width: 50%;
          font-family: PingFangSC-Medium;
          font-size: 0.36rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #222222;
          span {
            font-size: 0.28rem;
          }
        }
        .right-p {
          flex: 1;
          text-align: right;
          font-family: PingFangSC-Medium;
          font-size: 0.28rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #ff3087;
        }
        margin-bottom: 0.4rem;
      }
      .content-iconp {
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.24rem;
        letter-spacing: 0rem;
        color: #8a9096;
        padding-left: 0.5rem;
        margin-top: 0.2rem;
        word-break: break-all;
        &.iconp1 {
          background: url(../assets/images/order/1.png) left center no-repeat;
          background-size: 0.2rem 0.22rem;
        }
        &.iconp2 {
          background: url(../assets/images/order/2.png) left center no-repeat;
          background-size: 0.19rem 0.24rem;
        }
        &.iconp3 {
          background: url(../assets/images/order/3.png) left center no-repeat;
          background-size: 0.22rem 0.21rem;
        }
      }
    }
    .li-btn {
      position: absolute;
      bottom: 0.4rem;
      right: 0.3rem;
      width: 1.7rem;
      height: 0.6rem;
      border-radius: 0.3rem;
      border: solid 0.01rem #00b8f5;
      font-size: 0.24rem;
      text-align: center;
      color: #00b8f5;
      line-height: 0.6rem;
      &:active {
        background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
          linear-gradient(#f2f9fb, #f2f9fb);
        background-blend-mode: normal, normal;
        color: #fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/MissionHall.vue